import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { useGlobalModalContext } from "../GlobalModal";
import { useEffect, useState } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { TransitionProps } from '@mui/material/transitions';
import ChatScreen from '../../pages/Chat/ChatScreen';
import { addModalNavigation } from '../../helpers/Functions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export type ChatModalProps = {
    chatMemberCode: number;
    memberName: string;
    memberImage: string;
    isNavigateFromProfilePage: boolean
}


const ChatModal = NiceModal.create(({ chatMemberCode, memberName, memberImage, isNavigateFromProfilePage }: ChatModalProps) => {
    const modal = useModal();
    const openModalHashStateId = `chat?chatMemberCode=${chatMemberCode}`;

    useEffect(() => {
        if (modal.visible) {
            window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `./modal=${openModalHashStateId}`)
            localStorage.setItem("modalOpen", JSON.stringify({ name: "chat" }))
        }
    }, [modal.visible])

    const handleBack = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        modal.remove();
    }

    const handleCloseModalButton = () => {
        window.history.back();
        modal.hide();
    }

    return (
        <>
            <div>
                <Dialog
                    className="chat_modal"
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    fullScreen
                    disableEscapeKeyDown={true}
                    TransitionComponent={Transition}
                    open={modal.visible}
                    onClose={handleCloseModalButton}
                >
                    <div className='chat-container' style={{ overflowY: "auto" }}>
                        <ChatScreen isNavigateFromProfilePage={isNavigateFromProfilePage} chatMemberCode={chatMemberCode} memberName={memberName} memberImage={memberImage} />

                    </div>

                </Dialog>
            </div>
        </>


    )
})


export default ChatModal;